<template>
  <v-toolbar app :color="toolbar.back">
    <v-toolbar-side-icon v-if="menulateral.length>0" @click.stop="$emit('clique-menu-lateral')"></v-toolbar-side-icon>
    <v-toolbar-title class="headline">
      <span :class="toolbar.class">{{toolbar.title}}</span>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: ["qtdItensPedido","toolbar","menulateral"],
  data() {
    return {
      
    }
  },
  methods: {
    
  }
};
</script>

<style>
</style>